import { fontFamily } from "./fonts";

export { fontFamily };

/** Shared palette (replaces former Tailwind / className usage) */
export const colors = {
  black: "#000000",
  white: "#ffffff",
  cream: "#F9F5F3",
  cream2: "#F8F6F3",
  disgoBrown: "#6B4C3B",
  brownDark: "#4d2c1d",
  brownMuted: "#5E3D2D",
  brownDeep: "#4e2916",
  saddle: "#8B4513",
  accentTan: "#e6d7c7",
  accentTan2: "#E8D5C4",
  borderLight: "#d3d3d3",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray800: "#1f2937",
  yellow300: "#fde047",
  yellow400: "#facc15",
  yellow900: "#713f12",
  red: "#ef4444",
  /** Tailwind blue-300 — legal / link text */
  blue300: "#93c5fd",
  creamMuted: "#F0EBE6",
  warmTaupe: "#B8A79B",
  ratingChipBg: "rgba(156, 107, 66, 0.1)",
  /** Light faded brown for Specials / Passes / Hours chips on the map sheet */
  tabChipMutedBg: "#E8DED5",
  tabChipBorder: "rgba(107, 76, 59, 0.2)",
};
